import { RichText, InnerBlocks } from "@wordpress/block-editor";

function Save({ attributes }) {

  const { title,
          content,
          link,
          linkText,
          backgroundColorClass,
          ariaLabel } = attributes;

  const hasValidLink = link && linkText;

  return (
    <div className="col">
        <div className={`card vertical_img ${backgroundColorClass}`}>
          <div className="card-body">
            <RichText.Content
              tagName="h3"
              className="card-title h4"
              value={title}
            />
            <RichText.Content
              tagName="p"
              className="card-text"
              value={content}
            />
            {hasValidLink && (
              <a
                href={link}
                className="btn btn-link"
                aria-label={ariaLabel ? ariaLabel : undefined}
              >
                {linkText}
              </a>
            )}
          </div>


          <InnerBlocks.Content />


      </div>
    </div>
  );
}

export default Save;
